import { createBooleanStorageItem } from '@page/core/lib/web/storage';

import { useStorageAsState } from '../../web/useStorageAsState';

export const isNewUserStorage = createBooleanStorageItem('is-new-user', { storage: sessionStorage });

export const useIsNewUserStorage = () => {
  return useStorageAsState(isNewUserStorage);
};
